import React from 'react'
import "./Personal_Details.css"
import { Button, Form } from 'react-bootstrap'

function Personal_Details() {
    return (
        <>
            <section className='Personal_Details'>
                <Form>
                    <div className="row">
                        <div className="col-md-12">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Name of your Driving School</Form.Label>
                                <Form.Control placeholder="Enter Name of your Driving School" />
                            </Form.Group>
                        </div>
                        <div className="col-md-12">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Contact No.</Form.Label>
                                <Form.Control placeholder="Enter Contact No." />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Alternate Contact No.</Form.Label>
                                <Form.Control placeholder="Enter Alternate Contact No." />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Address</Form.Label>
                                <Form.Control as="textarea" rows={3} placeholder="Enter Address" />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>District</Form.Label>
                                <Form.Control placeholder="Enter District" />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Zipcode</Form.Label>
                                <Form.Control placeholder="Enter Zipcode" />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>State</Form.Label>
                                <Form.Control placeholder="Enter State" />
                            </Form.Group>
                        </div>
                    </div>


                    <div className='text-center'>

                        <Button className="search_btn" type="submit">
                            Save Changes
                        </Button>
                    </div>

                </Form>
            </section>
        </>
    )
}

export default Personal_Details